import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "top-canvas" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "wrapper-tabs" }
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "tabs" }
const _hoisted_10 = { class: "article-list" }
const _hoisted_11 = ["href", "title"]
const _hoisted_12 = { class: "article-list" }
const _hoisted_13 = ["href", "title"]
const _hoisted_14 = { class: "article-list" }
const _hoisted_15 = ["href", "title"]
const _hoisted_16 = { class: "article-list" }
const _hoisted_17 = ["href", "title"]
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "party-canvas" }
const _hoisted_20 = {
  href: "/news/partyNews",
  target: "_blank"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "case-canvas" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "tab-list" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header-title" }, [
    /*#__PURE__*/_createElementVNode("span", null, "工程设计与总包")
  ]),
  /*#__PURE__*/_createElementVNode("em", {
    class: "card-title-en",
    title: "ENGINEERING DESIGN AND GENERAL CONTRACTING"
  }, " ENGINEERING DESIGN AND GENERAL CONTRACTING "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/projects",
    target: "_blank"
  })
], -1)
const _hoisted_27 = { class: "card-list" }
const _hoisted_28 = ["href", "title"]
const _hoisted_29 = { class: "item-img" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "item-text" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header-title" }, [
    /*#__PURE__*/_createElementVNode("span", null, "环保咨询")
  ]),
  /*#__PURE__*/_createElementVNode("em", {
    class: "card-title-en",
    title: "ENVIRONMENTAL CONSULTING"
  }, "ENVIRONMENTAL CONSULTING"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/consult",
    target: "_blank"
  })
], -1)
const _hoisted_33 = { class: "card-list" }
const _hoisted_34 = ["href", "title"]
const _hoisted_35 = { class: "item-img" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "item-text" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-title" }, "装备与信息化")
  ]),
  /*#__PURE__*/_createElementVNode("em", {
    class: "card-title-en",
    title: "EQUIPMENT INFORMATIZATION"
  }, " EQUIPMENT INFORMATIZATION "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/equipment",
    target: "_blank"
  })
], -1)
const _hoisted_39 = { class: "card-list" }
const _hoisted_40 = ["href", "title"]
const _hoisted_41 = { class: "item-img" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "item-text" }
const _hoisted_44 = { class: "videos" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "video-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "video-title" }, "精选视频"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/videos",
    target: "_blank"
  }, "MORE")
], -1)
const _hoisted_46 = { class: "video-cont" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "video-canvas" }, [
  /*#__PURE__*/_createElementVNode("video", {
    id: "show_video",
    muted: "",
    controls: ""
  }, [
    /*#__PURE__*/_createElementVNode("source", {
      src: "/ivs/officialWebsite/video/home/company.mp4",
      type: "video/mp4"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "video-mask" })
], -1)
const _hoisted_48 = { class: "img-canvas" }
const _hoisted_49 = { class: "img-canvas-top" }
const _hoisted_50 = ["src"]
const _hoisted_51 = { class: "img-canvas-bottom" }
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "ad-link" }
const _hoisted_54 = { class: "ad-link-cont container" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "link-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "link-icon" }),
  /*#__PURE__*/_createTextVNode(" 友情链接 ")
], -1)
const _hoisted_56 = { class: "link-list" }
const _hoisted_57 = ["href", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_carousel, {
              autoplay: "",
              loop: "",
              interval: _ctx.interval,
              arrow: "never",
              height: _ctx.bannerHeight + 'px'
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movieList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_carousel_item, {
                    key: item,
                    height: _ctx.bannerHeight + 'px'
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: item.url,
                        target: "_blank",
                        class: "demo-carousel"
                      }, [
                        _createElementVNode("img", {
                          src: item.img,
                          alt: "公司动态图片",
                          ref_for: true,
                          ref: "bannerHeight",
                          onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imgLoad && _ctx.imgLoad(...args)))
                        }, null, 40, _hoisted_7),
                        _createElementVNode("p", {
                          title: item.title
                        }, _toDisplayString(item.title), 9, _hoisted_8)
                      ], 8, _hoisted_6)
                    ]),
                    _: 2
                  }, 1032, ["height"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["interval", "height"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_tabs, { type: "border-card" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, { label: "公司要闻" }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cpNewsList, (item) => {
                        return (_openBlock(), _createElementBlock("li", { key: item }, [
                          _createElementVNode("a", {
                            href: item.url,
                            target: "_blank",
                            title: item.title
                          }, [
                            _createElementVNode("div", null, _toDisplayString(item.title), 1),
                            _createElementVNode("div", null, _toDisplayString(item.time), 1)
                          ], 8, _hoisted_11)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, { label: "环境要闻" }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enNewsList, (item) => {
                        return (_openBlock(), _createElementBlock("li", { key: item }, [
                          _createElementVNode("a", {
                            href: item.url,
                            target: "_blank",
                            title: item.title
                          }, [
                            _createElementVNode("div", null, _toDisplayString(item.title), 1),
                            _createElementVNode("div", null, _toDisplayString(item.time), 1)
                          ], 8, _hoisted_13)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, { label: "党群动态" }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partyList, (item) => {
                        return (_openBlock(), _createElementBlock("li", { key: item }, [
                          _createElementVNode("a", {
                            href: item.url,
                            target: "_blank",
                            title: item.title
                          }, [
                            _createElementVNode("div", null, _toDisplayString(item.title), 1),
                            _createElementVNode("div", null, _toDisplayString(item.time), 1)
                          ], 8, _hoisted_15)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, { label: "公示公告" }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bulletinList, (item) => {
                        return (_openBlock(), _createElementBlock("li", { key: item }, [
                          _createElementVNode("a", {
                            href: item.url,
                            target: "_blank",
                            title: item.title
                          }, [
                            _createElementVNode("div", null, _toDisplayString(item.title), 1),
                            _createElementVNode("div", null, _toDisplayString(item.time), 1)
                          ], 8, _hoisted_17)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("a", _hoisted_20, [
          _createElementVNode("img", {
            src: require('@/assets/images/home/party.png'),
            alt: "党政专题"
          }, null, 8, _hoisted_21)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_el_carousel, {
          autoplay: "",
          loop: "",
          interval: _ctx.interval,
          arrow: "never",
          height: _ctx.bannerHeight2 + 'px'
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.caseList, (item) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: item,
                height: _ctx.bannerHeight2 + 'px'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: item.url,
                    target: "_blank",
                    class: "demo-carousel"
                  }, [
                    _createElementVNode("img", {
                      src: item.img,
                      alt: "案例图片",
                      ref_for: true,
                      ref: "bannerHeight2",
                      onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.imgLoad2 && _ctx.imgLoad2(...args)))
                    }, null, 40, _hoisted_24)
                  ], 8, _hoisted_23)
                ]),
                _: 2
              }, 1032, ["height"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["interval", "height"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_el_card, { class: "projects" }, {
          header: _withCtx(() => [
            _hoisted_26
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectsList, (item) => {
                return (_openBlock(), _createElementBlock("li", { key: item }, [
                  _createElementVNode("a", {
                    href: item.url,
                    target: "_blank",
                    title: item.title
                  }, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("img", {
                        src: item.img,
                        alt: ""
                      }, null, 8, _hoisted_30)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("p", null, _toDisplayString(item.title), 1)
                    ])
                  ], 8, _hoisted_28)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "consult" }, {
          header: _withCtx(() => [
            _hoisted_32
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consultList, (item) => {
                return (_openBlock(), _createElementBlock("li", { key: item }, [
                  _createElementVNode("a", {
                    href: item.url,
                    target: "_blank",
                    title: item.title
                  }, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("img", {
                        src: item.img,
                        alt: ""
                      }, null, 8, _hoisted_36)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("p", null, _toDisplayString(item.title), 1)
                    ])
                  ], 8, _hoisted_34)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { class: "equipment" }, {
          header: _withCtx(() => [
            _hoisted_38
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_39, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipmentList, (item) => {
                return (_openBlock(), _createElementBlock("li", { key: item }, [
                  _createElementVNode("a", {
                    href: item.url,
                    target: "_blank",
                    title: item.title
                  }, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("img", {
                        src: item.img,
                        alt: ""
                      }, null, 8, _hoisted_42)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("p", null, _toDisplayString(item.title), 1)
                    ])
                  ], 8, _hoisted_40)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("img", {
                src: require('@/assets/images/videos/mask02.png'),
                "data-src": "/ivs/officialWebsite/video/home/party.mp4",
                alt: ""
              }, null, 8, _hoisted_50)
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("img", {
                src: require('@/assets/images/videos/mask03.png'),
                "data-src": "/ivs/officialWebsite/video/home/mingtiangenghao.mp4",
                alt: ""
              }, null, 8, _hoisted_52)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _hoisted_55,
        _createElementVNode("ul", _hoisted_56, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkList, (item) => {
            return (_openBlock(), _createElementBlock("li", { key: item }, [
              _createElementVNode("a", {
                href: item.url,
                target: "_blank",
                title: item.title
              }, _toDisplayString(item.title), 9, _hoisted_57)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}